import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button, Card, CardContent, Typography, Grid, Dialog, DialogTitle, Tooltip, IconButton } from '@mui/material';
import { Delete as DeleteIcon, Edit as EditIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { useDestroyOrganizationMutation } from '../features/api/rest/apiOrganizationsSlice';
import OrganizationDialog from './OrganizationDialog';

function OrganizationCard({ id, name, slug, isAdmin, isActive }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [destroyOrganization] = useDestroyOrganizationMutation();
  const [isDeleting, setIsDeleting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const handleDelete = () => {
    destroyOrganization(id);
    setIsDeleting(false);
  };
  const goToOrganization = () => {
    navigate(`/profile/organizations/${id}/products`);
  };
  return (
    <Card className="Organization_Card">
      <Tooltip title={t('organizations.goToOrganization')} placement="top">
        <IconButton onClick={goToOrganization} sx={{ position: 'absolute', top: 1, right: 1 }}>
          <ArrowForwardIcon />
        </IconButton>
      </Tooltip>
      <CardContent sx={{ p: 0 }} onClick={goToOrganization}>
        <Typography
          sx={{
            margin: '1em',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
            textAlign: 'initial',
            overflow: 'hidden',
            wordBreak: 'break-word',
            height: '3em',
          }}
          variant="body1"
          color="text.primary"
        >
          {name}
        </Typography>
      </CardContent>
      {isAdmin && (
        <Grid container alignItems="center" mt={2} sx={{ gap: 2, display: 'flex', justifyContent: 'space-evenly' }}>
          <Grid item>
            <Tooltip title={t('common.actions.edit')} placement="top">
              <IconButton onClick={() => setIsEditing(true)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item>
            <Tooltip title={t('common.actions.delete')} placement="top">
              <IconButton onClick={() => setIsDeleting(true)}>
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      )}
      <Dialog open={isDeleting} onClose={() => setIsDeleting(false)}>
        <DialogTitle sx={{ textAlign: 'center' }}>{t('organizations.form.delete')}</DialogTitle>
        <Typography variant="body2" mx={4} sx={{ wordBreak: 'break-all' }}>
          {t('organizations.form.deleteMessage', { org: name })}
        </Typography>
        <Grid display="flex" justifyContent="flex-end" gap={1} p={2} pb={3}>
          <Button type="submit" onClick={() => setIsDeleting(false)} variant="outlined" color="secondary">
            {t('common.actions.close')}
          </Button>
          <Button type="submit" onClick={handleDelete} variant="contained" color="warning">
            {t('common.actions.delete')}
          </Button>
        </Grid>
      </Dialog>
      <OrganizationDialog actionType="edit" isOpen={isEditing} setIsOpen={setIsEditing} id={id} oldName={name} oldSlug={slug} oldIsActive={isActive} />
    </Card>
  );
}

OrganizationCard.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default OrganizationCard;
